import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { getActiveProjectSelector } from './projects/projects.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../shared/models/state';
import { ClearProjectAction } from './projects/projects.action';
import { CrazyCallConfigService } from './shared/services/crazycall-config.service';
import { initialConfig } from './shared/domain/initialConfig';
import { LanguageService } from '../shared/services/language.service';
import { AlertPaymentService } from '../shared/services/alert-payment.service';

@Component({
  selector: 'cc-lg-root',
  templateUrl: './lead-generation.component.html',
  styleUrls: ['./lead-generation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CrazyPopupRootComponent implements OnInit {
  public failedPayment: boolean;
  constructor(
    private crazyCallConfigService: CrazyCallConfigService,
    private router: Router,
    private store: Store<IState>,
    public languageService: LanguageService,
    public alertPaymentService: AlertPaymentService
  ) {}

  public projectName: string;
  public currentLanguage: string;

  ngOnInit() {
    this.store.select(getActiveProjectSelector).subscribe(data => {
      this.projectName = data && data.name;
    });

    this.alertPaymentService.onActivatePaymentAlert.subscribe(isPaymentFailed => {
      this.failedPayment = isPaymentFailed;
    });
  }

  createNewProject() {
    this.currentLanguage = this.languageService.getCookieLanguage();
    this.store.dispatch(new ClearProjectAction(initialConfig(this.crazyCallConfigService.appId, this.currentLanguage)));
  }
}
